
        import i18n from 'i18n';
        import flattenObject from 'util/flattenObject';
    
            import ns952638c2d116e0a8822926addca438f7en from './en.yaml'
            i18n.addResourceBundle('en', '952638c2d116e0a8822926addca438f7', flattenObject(ns952638c2d116e0a8822926addca438f7en), true, true);
        
        export default '952638c2d116e0a8822926addca438f7';
    